import { useEffect, useRef, useState } from "react";
import FilterBar from "../../../components/topBarFilter";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import { Box } from "@mui/system";
import {
  Outlet,
  useLocation,
  useNavigate,
  useOutletContext,
} from "react-router-dom";
import {
  Alert,
  Autocomplete,
  Button,
  Checkbox,
  Chip,
  Divider,
  LinearProgress,
  Snackbar,
  TextField,
  Tooltip,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { useTheme } from "@emotion/react";
import useStyles from "./styles";
import dayjs from "dayjs";
import { DateTimePicker } from "@mui/x-date-pickers";
import {
  Cached,
  SettingsRemote,
  HttpOutlined,
  Menu as MenuIcon,
} from "@mui/icons-material";
import ButtonTime from "../../../components/buttonTime";
import Cronometro from "./cronometro";
import useCronometro from "./cronometro/useCronometro";
import { getDeviceConfig, getDeviceType } from "../../../utils/deviceConfig";
import VirtualizedAutocomplete from "../../../components/virtualization/virtualizedAutocomplete";
import { getClienteOptionLabel } from "../../../components/grupoEconomico/helpers";
import {
  CampoCliente,
  renderOpcaoCliente,
} from "../../../components/opcaoCliente";
import minMax from "dayjs/plugin/minMax";

import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import ConfusedMale from "../../../components/artsPersonComponent/confusedMale";
import ModalAcessoHttp from "./modalAcessoHttp";
import { getErpPrincipal, temErp } from "../../../services/erpSistema";
dayjs.extend(minMax);
dayjs.extend(isSameOrBefore);

const ROTULO_SERVICO = {
  HUBSOFT: "Serviço",
  VOALLE: "Contrato",
  IXC: "Contrato",
  VERO: "Contrato",
};

// Tipo do ERP de um cliente da lista. Grupo econômico (sem ERP próprio): o dos
// membros se forem do mesmo tipo; misturado, padrão HubSoft. Sem nada: o ERP
// do sistema.
function tipoErpDoCliente(cliente) {
  if (cliente?.erp?.tipo) return cliente.erp.tipo;
  const tipos = [
    ...new Set(
      (cliente?.GrupoEconomicoMembros || [])
        .map((rl) => rl?.cliente?.erp?.tipo)
        .filter(Boolean),
    ),
  ];
  if (tipos.length === 1) return tipos[0];
  if (tipos.includes("HUBSOFT")) return "HUBSOFT";
  return tipos[0] || (temErp("HUBSOFT") ? "HUBSOFT" : getErpPrincipal());
}

export default function LayoutDashboard() {
  const { api, controllerDashboard, setControllerDashboard } =
    useOutletContext();
  const theme = useTheme();
  const styles = useStyles(theme);
  const navigate = useNavigate();
  const location = useLocation();
  const [openFilter, setOpenFilter] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [anchorElAcesso, setAnchorElAcesso] = useState(null);
  const openAcesso = Boolean(anchorElAcesso);
  const [openHttpModal, setOpenHttpModal] = useState(false);
  const [httpCredentials, setHttpCredentials] = useState({ loading: false });
  const [sfpInterfacesCache, setSfpInterfacesCache] = useState({});
  const [loadingSfpCache, setLoadingSfpCache] = useState(false);
  const [snackbar, setSnackbar] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [isValidRange, setIsValidRange] = useState(false);
  const [propsLayout, setPropsLayout] = useState({
    optionsTime: null, //opções de tempo
    rangeDataTime: null, //intervalo de tempo do dataPicker
    rangeDays: null, // Numero de dias maximo para qualquer range
    gruposFlowCliente: {
      selectGrupos: [],
      allGruposCliente: [],
    },
  });
  const [pendingGrupos, setPendingGrupos] = useState(
    propsLayout?.gruposFlowCliente?.selectGrupos || [],
  );
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [windowWith, setWindowWith] = useState(window.innerWidth);

  // O cronômetro de auto-atualização vive no hook useCronometro (ver abaixo).

  // Rótulo da referência de um serviço, pelo ERP do dono dele (no grupo
  // econômico, o membro; senão, o cliente selecionado).
  const configErp = (invertInfo, ownerClienteId) => {
    const dono = ownerClienteId
      ? allClients
          ?.find((cliente) => cliente?.id === filterData?.clienteId)
          ?.GrupoEconomicoMembros?.find((rl) => rl?.cliente?.id === ownerClienteId)
          ?.cliente
      : null;
    switch (dono?.erp?.tipo || erp) {
      case "HUBSOFT":
        return {
          labelRef: invertInfo ? "Serviço" : "Referência",
        };
        break;
      case "IXC":
        return {
          labelRef: invertInfo ? "Contrato" : "Descrição auxiliar",
        };
        break;
      default:
        return {
          labelRef: "",
        };
        break;
    }
  };
  //loading #########################################3#####
  const [loadingClient, setLoadingClient] = useState(false);
  const [loadingService, setLoadingService] = useState(false);
  //TEMPO SELECIONADO E FILTRO ################################################
  const [selectTime, setSelectTime] = useState(5);
  const [filterData, setFilterData] = useState({
    clienteId: "",
    serviceId: "",
    interfaceId: "",
    hostId: "",
    initialDate: dayjs()
      .subtract(6, "hour")
      .set("second", 0)
      .set("millisecond", 0)
      .toDate(),
    finalDate: dayjs().set("second", 0).set("millisecond", 0).toDate(),
  });
  //HOSTS , INTERFACES , SERVIÇOS E CLIENTES ###########################################
  const [allClients, setAllClients] = useState([]);
  const [allServicesCliente, setAllServiceCliente] = useState([]);
  // ERP do cliente selecionado: decide os textos do seletor de serviço.
  const erp = tipoErpDoCliente(
    allClients?.find((cliente) => cliente?.id === filterData?.clienteId),
  );
  const labelErp = ROTULO_SERVICO[erp] || "";
  const [storageFilterData, setStorageFilterData] = useState(null);
  const [isConexoes, setIsConexoes] = useState(false);
  const [deviceConfig, setDeviceConfig] = useState({});

  // vvvvv Host vvvvv
  const [loadingHostsGroupedByType, setLoadingHostsGroupedByType] =
    useState(false);
  const [servicesWithConfig, setServicesWithConfig] = useState([]);
  const [hostsGroupedByType, setHostsGroupedByType] = useState({
    cpes: {},
    onus: {},
    links: {},
    sessions: {},
  });
  const [hostsOptions, setHostsOptions] = useState([]);
  const [selectedHostOption, setSelectedHostOption] = useState(null);
  const [filteredServicesOptions, setFilteredServicesOptions] = useState([]);
  // Interface
  const [loadingInterfaceOptions, setLoadingInterfaceOptions] = useState(false);
  const [interfaceOptions, setInterfaceOptions] = useState([]);
  const interfaceRetryCount = useRef(0);
  // Controller PRÓPRIO do fetch de hosts. Não compartilha o controllerDashboard
  // para que a busca de hosts não seja abortada por outros consumidores (páginas,
  // interface, etc.) — abortá-la deixava hostsGroupedByType vazio e fazia o efeito
  // de auto-seleção limpar o serviço selecionado ("serviço às vezes some").
  const hostsGroupedByTypeRef = useRef(null);

  /**
   * Obter Hosts agrupados por tipo
   * quando o cliente é selecionado
   */
  useEffect(() => {
    setHostsGroupedByType({
      cpes: {},
      onus: {},
      links: {},
      sessions: {},
    });
    if (!!filterData?.clienteId && allServicesCliente?.length > 0) {
      getHostsGroupedByType();
      setServicesWithConfig([]);
    }
  }, [allServicesCliente]);

  useEffect(() => {
    setSfpInterfacesCache({});
  }, [selectedHostOption]);

  /**
   * Filtrar hosts
   * quando o path da rota muda
   * ou quando o serviceId muda
   */
  useEffect(() => {
    hostFilter();
  }, [window.location.pathname, hostsGroupedByType, filterData?.serviceId]);

  /**
   * Obter interfaces do host selecionado
   */
  useEffect(() => {
    if (selectedHostOption) {
      getInterfaceOptions();
    }
  }, [selectedHostOption]);

  useEffect(() => {
    interfaceRetryCount.current = 0;
  }, [selectedHostOption]);

  useEffect(() => {
    if (!hostsGroupedByType || !allServicesCliente) return;

    const path = {
      cpe: [
        "/interno/dash/overview",
        "/interno/dash/saude",
        "/interno/dash/disponibilidade",
        "/interno/dash/sfp",
        "/interno/dash/firewall",
      ],
      onu: ["/interno/dash/onu", "/interno/dash/teste"],
      linkAndSession: ["/interno/dash/bgp"],
    };
    const currentPath = window.location.pathname;
    let relevantTypes = [];
    if (path.cpe.some((p) => p === currentPath)) relevantTypes = ["cpes"];
    else if (path.onu.some((p) => p === currentPath)) relevantTypes = ["onus"];
    else if (path.linkAndSession.some((p) => p === currentPath))
      relevantTypes = ["links", "sessions"];

    // 1. Criamos um objeto para mapear o ID do serviço à quantidade de itens
    let itemCounts = {};
    relevantTypes.forEach((type) => {
      if (hostsGroupedByType[type]) {
        Object.entries(hostsGroupedByType[type]).forEach(([id, hosts]) => {
          if (hosts && hosts.length > 0) {
            const stringId = String(id);
            // Soma a quantidade de hosts caso o ID apareça em mais de um tipo relevante
            itemCounts[stringId] = (itemCounts[stringId] || 0) + hosts.length;
          }
        });
      }
    });

    // 2. Mapeamos TODOS os serviços, adicionando a propriedade 'itemsCount'
    const newFilteredOptions = allServicesCliente.map((service) => {
      const serviceId = String(service?.id_cliente_servico);
      return {
        ...service,
        itemsCount: itemCounts[serviceId] || 0, // Retorna a soma ou 0 se não houver itens
      };
    });

    // Grupo econômico: MUI groupBy exige as options ordenadas pelo grupo
    if (newFilteredOptions.some((service) => service?.ownerNome)) {
      newFilteredOptions.sort((a, b) =>
        (a?.ownerNome || "").localeCompare(b?.ownerNome || ""),
      );
    }

    setFilteredServicesOptions(newFilteredOptions);
  }, [hostsGroupedByType, allServicesCliente, window.location.pathname]);

  useEffect(() => {
    if (
      !loadingHostsGroupedByType &&
      !loadingService &&
      allServicesCliente?.length > 0
    ) {
      setFilterData((prev) => {
        const currentServiceId = prev?.serviceId?.toString();

        if (filteredServicesOptions.length > 0) {
          const isCurrentServiceValid = filteredServicesOptions.some(
            (service) =>
              service?.id_cliente_servico?.toString() === currentServiceId,
          );

          if (!isCurrentServiceValid) {
            return {
              ...prev,
              serviceId:
                filteredServicesOptions[0]?.id_cliente_servico?.toString() ||
                "",
              hostId: "",
              interfaceId: "",
            };
          }
        } else {
          if (currentServiceId !== "") {
            return {
              ...prev,
              serviceId: "",
              hostId: "",
              interfaceId: "",
            };
          }
        }
        return prev;
      });
    }
  }, [
    filteredServicesOptions,
    loadingHostsGroupedByType,
    loadingService,
    allServicesCliente,
  ]);

  /**
   * Aplica identificadores de host em filterData devolvendo o PRÓPRIO `prev`
   * quando nenhum valor mudou. Espalhar `{...prev}` sempre cria uma identidade
   * nova, e as páginas de dashboard dependem de `[filterData]` — ou seja, um
   * spread inócuo custava uma onda inteira de requisições.
   */
  function aplicarHost(prev, valores) {
    const next = { ...prev, ...valores };
    const mudou = Object.keys(valores).some(
      (chave) => prev?.[chave] !== next[chave],
    );
    return mudou ? next : prev;
  }

  /**
   * Filtrar hosts exibidos
   */
  function hostFilter() {
    if (!filterData?.serviceId || !hostsGroupedByType) return;
    // Definir os caminhos de cada tipo de host
    const path = {
      cpe: [
        "/interno/dash/overview",
        "/interno/dash/saude",
        "/interno/dash/disponibilidade",
        "/interno/dash/sfp",
        "/interno/dash/firewall",
      ],
      onu: ["/interno/dash/onu", "/interno/dash/teste"],
      linkAndSession: ["/interno/dash/bgp"],
    };

    // Obter o caminho atual
    const currentPath = window.location.pathname;
    // Filtrar hosts
    let filteredHosts = [];
    if (path?.cpe?.some((path) => path === currentPath)) {
      // Se for CPE
      filteredHosts =
        hostsGroupedByType?.["cpes"]?.[filterData?.serviceId] || [];
    } else if (path?.onu?.some((path) => path === currentPath)) {
      // Se for ONU
      filteredHosts =
        hostsGroupedByType?.["onus"]?.[filterData?.serviceId] || [];
    } else if (path?.linkAndSession?.some((path) => path === currentPath)) {
      // Se for Link e Session
      filteredHosts = [
        ...(hostsGroupedByType?.["links"]?.[filterData?.serviceId] || []),
        ...(hostsGroupedByType?.["sessions"]?.[filterData?.serviceId] || []),
      ];
      // Deduplicate by hostId
      filteredHosts = Array.from(
        new Map(filteredHosts.map((item) => [item?.hostId, item])).values(),
      );
    }
    // Atualizar as opções de filtro
    setHostsOptions(filteredHosts);
    // Selecionar o host armazenado no local storage ou o primeiro host
    const filterDataStorage = JSON.parse(localStorage.getItem("filterData"));

    if (
      !!filterDataStorage &&
      !!filterDataStorage?.hostId &&
      filteredHosts?.some(
        (host) =>
          parseInt(host?.hostId) === parseInt(filterDataStorage?.hostId),
      )
    ) {
      setFilterData((prev) =>
        aplicarHost(prev, {
          hostId: filterDataStorage?.hostId,
          device: filterDataStorage?.device,
          //identificadores do schema
          fabricante: filterDataStorage?.fabricante,
          funcao: filterDataStorage?.funcao,
          modelo: filterDataStorage?.modelo,
        }),
      );
      setSelectedHostOption(
        filteredHosts?.find(
          (host) =>
            parseInt(host?.hostId) === parseInt(filterDataStorage?.hostId),
        ) || null,
      );
    } else {
      setFilterData((prev) =>
        aplicarHost(prev, {
          hostId:
            filteredHosts?.[0]?.hostid || filteredHosts?.[0]?.hostId || null,
          device: filteredHosts?.[0]?.device || null,
          //identificadores do schema
          fabricante: filteredHosts?.[0]?.fabricante || null,
          funcao: filteredHosts?.[0]?.funcao || null,
          modelo: filteredHosts?.[0]?.modelo || null,
        }),
      );
      setSelectedHostOption(filteredHosts?.[0] || null);
    }
  }

  /**
   * Buscar hosts agrupados por tipo
   */
  async function getHostsGroupedByType(params) {
    // Aborta o controller compartilhado só para cancelar dados de página obsoletos
    // ao trocar de cliente — mas o fetch de hosts abaixo usa controller próprio.
    if (controllerDashboard) {
      controllerDashboard.abort();
      setHostsGroupedByType({
        cpes: {},
        onus: {},
        links: {},
        sessions: {},
      });
    }

    // Cancela um fetch de hosts anterior ainda em andamento (ex.: troca rápida de cliente).
    if (hostsGroupedByTypeRef.current) {
      hostsGroupedByTypeRef.current.abort();
    }
    const newController = new AbortController();
    const signal = newController.signal;
    hostsGroupedByTypeRef.current = newController;

    try {
      setLoadingHostsGroupedByType(true);

      const response = await api.post(
        "/interno/findMany/hostsCliente",
        {
          clienteId: filterData?.clienteId || allClients?.[0]?.id,
          includeEmptyHosts: true,
          mapHostsByServiceAndEquipmentType: true,
          includeInterfaceTags: true,
        },
        {
          signal,
        },
      );
      setHostsGroupedByType(
        response.data || {
          cpes: {},
          onus: {},
          links: {},
          sessions: {},
        },
      );
      setServicesWithConfig([
        ...new Set(
          Object.values(response.data).flatMap((obj) => Object.keys(obj)),
        ),
      ]);
    } catch (error) {
      // Aborto é esperado (foi substituído por um fetch mais novo) — não é erro.
      if (!signal.aborted) console.error(error);
    } finally {
      // Só libera o loading se este fetch não foi abortado; se foi, o fetch que o
      // substituiu é quem controla o loading (evita loading preso / serviço limpo).
      if (!signal.aborted) setLoadingHostsGroupedByType(false);
    }
  }

  /**
   * Buscar interfaces do host selecionado
   */
  const getInterfaceOptions = async () => {
    try {
      if (controllerDashboard) {
        controllerDashboard.abort();
        setInterfaceOptions([]);
      }

      // Se algum selectedHostOption?.groups?.name contem "ICMP"
      const isIcmpGroup = selectedHostOption?.groups?.some((group) =>
        group?.name?.includes("ICMP"),
      );

      if (!!isIcmpGroup) {
        setInterfaceOptions([]);
        setFilterData((prev) =>
          prev?.interfaceId === "ICMP"
            ? prev
            : { ...prev, interfaceId: "ICMP" },
        );
        return;
      }

      const newController = new AbortController();
      const signal = newController.signal;
      setControllerDashboard(newController);

      setLoadingInterfaceOptions(true);
      // Se for OLT
      let response;
      if (selectedHostOption?.host?.startsWith("OLT")) {
        const onuList = hostsOptions?.map((host) => host?.onuItem);
        setInterfaceOptions(onuList || []);
        response = {
          data:
            onuList?.length > 0
              ? onuList?.map((onu) => {
                  return { name: onu };
                })
              : [],
        };
      } else {
        response = await api.post(
          "/zabbix/interfaceList",
          {
            hostId: selectedHostOption?.hostId,
          },
          {
            signal,
          },
        );
        setInterfaceOptions(response?.data || []);
      }

      const savedInterfaceId = storageFilterData?.interfaceId;

      const isSavedInterfaceValid =
        !!savedInterfaceId &&
        response?.data?.some((item) => item?.name === savedInterfaceId);

      // Devolver `prev` quando o valor não mudou evita uma identidade nova de
      // filterData — que faria as páginas (deps [filterData]) refazerem a onda
      // inteira de requisições sem nenhum dado ter mudado.
      if (isSavedInterfaceValid) {
        setFilterData((prev) =>
          prev?.interfaceId === savedInterfaceId
            ? prev
            : { ...prev, interfaceId: savedInterfaceId },
        );
      } else {
        if (selectedHostOption?.host?.startsWith("OLT")) {
          const onuInterfaceId = selectedHostOption?.onuItem || "";
          setFilterData((prev) =>
            prev?.interfaceId === onuInterfaceId
              ? prev
              : { ...prev, interfaceId: onuInterfaceId },
          );
        } else {
          const validHostInterface =
            selectedHostOption?.hostsClienteInterfaces?.find(
              (hostInterface) => {
                const ifaceName =
                  typeof hostInterface === "string"
                    ? hostInterface
                    : hostInterface?.interface;
                return response?.data?.some(
                  (dataItem) => dataItem?.name === ifaceName,
                );
              },
            );

          const validInterfaceName =
            typeof validHostInterface === "string"
              ? validHostInterface
              : validHostInterface?.interface;
          const firstHostInterface =
            selectedHostOption?.hostsClienteInterfaces?.[0];
          const firstInterfaceName =
            typeof firstHostInterface === "string"
              ? firstHostInterface
              : firstHostInterface?.interface;

          const novoInterfaceId =
            validInterfaceName ||
            firstInterfaceName ||
            response?.data?.[0]?.name;
          setFilterData((prev) =>
            prev?.interfaceId === novoInterfaceId
              ? prev
              : { ...prev, interfaceId: novoInterfaceId },
          );
        }
      }
    } catch (error) {
      const isAbort =
        error?.code === "ERR_CANCELED" || error?.name === "CanceledError";
      if (isAbort && interfaceRetryCount.current === 0) {
        interfaceRetryCount.current = 1;
        return getInterfaceOptions();
      }
      if (!isAbort) console.error(error);
    } finally {
      setLoadingInterfaceOptions(false);
    }
  };

  const verificarSfpInterfaces = async (interfaceList, signal) => {
    if (location.pathname !== "/interno/dash/sfp") return;
    const currentHostId = selectedHostOption?.hostId || filterData?.hostId;
    if (!interfaceList?.length || !currentHostId) return;

    setLoadingSfpCache(true);
    try {
      const allInterfaceNames = interfaceList
        .map((i) => i?.name)
        .filter(Boolean);

      const response = await api.post(
        "/zabbix/items/list",
        {
          hostid: currentHostId,
          filterBySchema: true,
          interface: allInterfaceNames,
          groupByInterface: true,
          fabricante: filterData?.fabricante,
          funcao: filterData?.funcao,
          modelo: filterData?.modelo,
          dash: "sfp",
        },
        { signal },
      );

      setSfpInterfacesCache(response?.data?.interfaces || {});
    } catch (error) {
      const isAbort =
        error?.code === "ERR_CANCELED" || error?.name === "CanceledError";
      if (!isAbort)
        console.error("Erro ao verificar SFP por interface:", error);
    } finally {
      setLoadingSfpCache(false);
    }
  };

  // useEffect separado para re-executar a verificação sempre que interfaceOptions
  // mudar — cobre troca de filtros que não alteram selectedHostOption diretamente.
  useEffect(() => {
    if (!interfaceOptions?.length) return;
    const controller = new AbortController();
    verificarSfpInterfaces(interfaceOptions, controller.signal);
    return () => controller.abort();
  }, [interfaceOptions, location.pathname]);

  // ^^^^^ Host ^^^^^

  useEffect(() => {
    setPendingGrupos(propsLayout?.gruposFlowCliente?.selectGrupos || []);
  }, [propsLayout?.gruposFlowCliente?.selectGrupos]);

  //Caso tenha no localStorage um range maior de 7 dias, fazer a tela do easyFlow iniciar com 6 horas (PADRAO)
  useEffect(() => {
    if (!propsLayout?.rangeDays) return;

    const { initialDate, finalDate } = filterData || {};

    if (!initialDate || !finalDate) return;

    const diffInDays = dayjs(finalDate).diff(
      dayjs(initialDate),
      "day",
      true, // considera frações de dia
    );

    if (diffInDays > propsLayout?.rangeDays) {
      handleSelectTime(5);
    }
  }, [
    window.location.pathname,
    filterData?.initialDate,
    filterData?.finalDate,
    propsLayout,
  ]);

  useEffect(() => {
    //Funções a serem executadas ao carregar a página
    /*     apiGetClientes(); */

    const handleResize = () => {
      setWindowWith(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const now = dayjs();
    setIsValidRange(
      dayjs.isDayjs(startDate) &&
        dayjs.isDayjs(endDate) &&
        startDate.isValid() &&
        endDate.isValid() &&
        !startDate.isAfter(endDate) &&
        !endDate.isBefore(startDate) &&
        !startDate.isAfter(now) &&
        !endDate.isAfter(now) &&
        (propsLayout?.rangeDays //Caso esteja no easyflow, permitir range maximo de 7 dias
          ? startDate && endDate
            ? dayjs(endDate).isSameOrBefore(
                dayjs.min(
                  dayjs(startDate).add(propsLayout?.rangeDays, "day"),
                  dayjs(),
                ),
              )
            : false
          : true),
    );
  }, [endDate, startDate]);

  useEffect(() => {
    if (filterData?.hostId) {
      const config = getDeviceConfig(filterData?.device);
      setDeviceConfig(config);
      //getInterface(); eu
    }
  }, [filterData?.hostId]);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    getClients(); //PUXA TODOS OS CLIENTS
  }, []);

  // Cancela o fetch de hosts ainda em voo ao sair da dash — sem isto a resposta
  // chega depois do unmount e o controller nunca é liberado.
  useEffect(() => {
    return () => {
      hostsGroupedByTypeRef.current?.abort();
      hostsGroupedByTypeRef.current = null;
    };
  }, []);

  const [firstDeviceLoaded, setFirstDeviceLoaded] = useState(false);
  useEffect(() => {
    const isNoInterfaceDash =
      window.location.pathname.includes("/interno/dash/firewall") ||
      window.location.pathname.includes("/interno/dash/bgp") ||
      window.location.pathname.includes("/interno/dash/flow");

    const storedFilterData = localStorage.getItem("filterData");
    if (
      !firstDeviceLoaded &&
      storedFilterData &&
      (isNoInterfaceDash || !filterData?.interfaceId) &&
      !!filterData?.hostId &&
      !!filterData?.serviceId &&
      !!filterData?.clienteId
    ) {
      setFirstDeviceLoaded(true);
      const parsedFilterData = JSON.parse(storedFilterData);
      setFilterData((prev) => ({
        ...parsedFilterData,
        initialDate: parsedFilterData?.initialDate || prev?.initialDate,
        finalDate: parsedFilterData?.finalDate || prev?.finalDate,
      }));
      return;
    }

    if (
      filterData?.finalDate &&
      filterData?.initialDate &&
      (isNoInterfaceDash || filterData?.interfaceId) &&
      filterData?.hostId &&
      filterData?.serviceId &&
      filterData?.clienteId
    ) {
      setFirstDeviceLoaded(true);
      const dataFilterStorage = {
        interfaceId: filterData?.interfaceId,
        clienteId: filterData?.clienteId,
        serviceId: filterData?.serviceId,
        hostId: filterData?.hostId,
        selectTime: selectTime,
        initialDate: filterData?.initialDate,
        finalDate: filterData?.finalDate,
        device: filterData?.device,
        //identificadores do schema
        fabricante: filterData?.fabricante,
        funcao: filterData?.funcao,
        modelo: filterData?.modelo,
      };
      localStorage.setItem("filterData", JSON.stringify(dataFilterStorage));
    }
  }, [filterData]);

  useEffect(() => {
    const pagesDash = ["/interno/dash/conexoes"];

    setIsConexoes(
      pagesDash?.find((page) => window.location.pathname.includes(page))
        ? true
        : false,
    );
  }, [window.location.pathname]);

  useEffect(() => {
    const cliente = allClients?.find(
      (cliente) => cliente?.id === filterData?.clienteId,
    );

    // O backend acha o cliente pelo clienteId e consulta o ERP dele (no grupo
    // econômico, o de cada membro).
    if (cliente) getServicesCliente(cliente?.cnpj, cliente?.clienteErpId);
  }, [filterData?.clienteId]);

  const optionsTime = {
    0: {
      value: dayjs()
        .subtract(5, "minute")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimos 5 minutos",
    },
    1: {
      value: dayjs()
        .subtract(15, "minute")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimos 15 minutos",
    },
    2: {
      value: dayjs()
        .subtract(30, "minute")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimos 30 minutos",
    },
    3: {
      value: dayjs()
        .subtract(1, "hour")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Última hora",
    },
    4: {
      value: dayjs()
        .subtract(3, "hour")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimas 3 horas",
    },
    5: {
      value: dayjs()
        .subtract(6, "hour")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimas 6 horas",
    },
    6: {
      value: dayjs()
        .subtract(12, "hour")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimas 12 horas",
    },
    7: {
      value: dayjs()
        .subtract(24, "hour")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimas 24 horas",
    },
    8: {
      value: dayjs()
        .subtract(2, "day")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimos 2 dias",
    },
    9: {
      value: dayjs()
        .subtract(7, "day")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimos 7 dias",
    },
    10: {
      value: dayjs()
        .subtract(30, "day")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimos 30 dias",
    },
    11: {
      value: dayjs()
        .subtract(90, "day")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimos 90 dias",
    },
    12: {
      value: dayjs()
        .subtract(6, "month")
        .set("second", 0)
        .set("millisecond", 0)
        .toDate(),
      label: "Últimos 6 meses",
    },
  };

  const remoteAccessReady =
    !!filterData?.clienteId && !!filterData?.serviceId && !!filterData?.hostId;

  const handleOpenRemoteAccess = () => {
    if (!remoteAccessReady) {
      setSnackbar({
        children:
          "Selecione cliente, serviço e host para abrir o acesso remoto.",
        severity: "warning",
      });
      return;
    }

    localStorage.setItem(
      "filterData",
      JSON.stringify({
        ...filterData,
        selectTime,
        initialDate: filterData?.initialDate || startDate || "",
        finalDate: filterData?.finalDate || endDate || "",
      }),
    );

    navigate(`/interno/home/perfil/remoteAccess/${filterData?.clienteId}`);
  };

  const handleOpenAcessoMenu = (event) => {
    setAnchorElAcesso(event.currentTarget);
  };

  const handleCloseAcessoMenu = () => {
    setAnchorElAcesso(null);
  };

  const handleAbrirAcessoHttp = () => {
    handleCloseAcessoMenu();
    if (!remoteAccessReady) {
      setSnackbar({
        children: "Selecione cliente, serviço e host para abrir o acesso HTTP.",
        severity: "warning",
      });
      return;
    }
    setOpenHttpModal(true);
    setHttpCredentials({ loading: true });

    api
      .post("/zabbix/hosts/macros", { hostId: filterData?.hostId })
      .then((res) => {
        const macros = res.data?.macros || [];
        const findMacro = (name) =>
          macros.find((m) => m.macro === name)?.value || "";
        setHttpCredentials({
          loading: false,
          url: findMacro("{$HTTP_ADDRESS}"),
          user: findMacro("{$HTTP_USER}"),
          pass: findMacro("{$HTTP_PASS}"),
        });
      })
      .catch((err) => {
        console.error(err);
        setHttpCredentials({ loading: false });
        setSnackbar({
          children: "Erro ao buscar credenciais HTTP.",
          severity: "error",
        });
      });
  };

  const actions = [
    {
      icon: <FilterAltOutlinedIcon />,
      name: "Filtro",
      onClick: () => setOpenFilter(true),
    },
    {
      icon: <SettingsRemote />,
      name: "Acesso Remoto",
      onClick: handleOpenRemoteAccess,
    },
    {
      icon: <HttpOutlined />,
      name: "Acesso HTTP",
      onClick: handleAbrirAcessoHttp,
    },
    ...(selectTime || selectTime === 0
      ? [
          {
            icon: <Cached />,
            name: "Atualizar",
            onClick: () => handleSelectTime(selectTime),
          },
        ]
      : []),
  ];

  const getClients = async () => {
    if (controllerDashboard) {
      controllerDashboard.abort();

      setAllServiceCliente([]);
    }

    const newController = new AbortController();
    const signal = newController.signal;
    setControllerDashboard(newController);
    setLoadingClient(true);
    const filterDataStorage = JSON.parse(localStorage.getItem("filterData"));

    setStorageFilterData(filterDataStorage);

    if (filterDataStorage?.selectTime || filterDataStorage?.selectTime === 0) {
      setSelectTime(filterDataStorage?.selectTime);
    } else if (filterDataStorage?.initialDate && filterDataStorage?.finalDate) {
      setSelectTime(null);
      setStartDate(dayjs(filterDataStorage?.initialDate));
      setEndDate(dayjs(filterDataStorage?.finalDate));
      setFilterData((prev) => ({
        ...prev,
        initialDate: filterDataStorage?.initialDate,
        finalDate: filterDataStorage?.finalDate,
      }));
    }
    try {
      const response = await api.post(
        "/interno/find/clientsOnlyWithHost",
        { onlyClientsWithHost: true },
        { signal },
      );

      setAllClients(response?.data);

      //Verificar se o cliente do localStorage existe na lista de clientes com host
      const clienteExiste = response?.data?.find(
        (cliente) => cliente?.id === filterDataStorage?.clienteId,
      );

      // Verifica se existe localStorage
      // Caso nao exista, setar primeiros dados
      if (!filterDataStorage || !clienteExiste) {
        setFilterData((prev) => ({
          ...prev,
          clienteId: response.data?.[0]?.id,
        }));
      } else {
        setFilterData((prev) => ({
          ...prev,
          clienteId: filterDataStorage?.clienteId,
        }));
      }
    } catch (error) {
      console.error("Error fetching clients:", error);
    } finally {
      setLoadingClient(false);
    }
  };

  const getServicesCliente = async (cnpj, clienteErpId) => {
    if (controllerDashboard) {
      controllerDashboard.abort();
    }

    const newController = new AbortController();
    const signal = newController.signal;
    setControllerDashboard(newController);
    setLoadingService(true);

    try {
      const response = await api.post(
        "/interno/find/allServiceClient",
        {
          cnpj: cnpj,
          idClienteErp: clienteErpId,
          // Grupos econômicos não têm cnpj/clienteErpId — o backend resolve
          // pelo clienteId e consolida os contratos dos membros
          clienteId: filterData?.clienteId,
        },
        {
          signal,
        },
      );
      setAllServiceCliente(response?.data || []);

      if (!storageFilterData || !storageFilterData?.serviceId) {
        setFilterData((prev) => ({
          ...prev,
          serviceId: response?.data?.[0]?.id_cliente_servico?.toString(),
        }));
      } else {
        setFilterData((prev) => ({
          ...prev,
          serviceId: storageFilterData?.serviceId?.toString(),
        }));
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingService(false);
    }
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleStartChange = (newValue) => {
    setStartDate(newValue);
    if (newValue?.isAfter(endDate)) {
      setEndDate(newValue);
    }
  };
  const handleEndChange = (newValue) => {
    setEndDate(newValue);
  };
  const handleAplicar = () => {
    setFilterData((prev) => ({
      ...prev,
      initialDate: dayjs(startDate).toDate(),
      finalDate: dayjs(endDate).toDate(),
    }));
    setSelectTime(null);
    handleClose();
  };

  const handleAplicarZoom = (startDate, endDate) => {
    setFilterData((prev) => ({
      ...prev,
      initialDate: dayjs(startDate).toDate(),
      finalDate: dayjs(endDate).toDate(),
    }));
    setSelectTime(null);
    handleClose();
  };

  const handleSelectTime = (key) => {
    setSelectTime(key);
    setStartDate(null);
    setEndDate(null);
    handleClose();

    setFilterData((prev) => ({
      ...prev,
      initialDate: optionsTime[key]?.value,
      finalDate: dayjs().set("second", 0).set("millisecond", 0).toDate(),
    }));
  };

  const toggleDrawer = (newOpen) => () => {
    setOpenFilter(newOpen);
  };

  const {
    counter,
    setCounter,
    loadingCronometro,
    setLoadingCronometro,
    startCronometro,
    stopCronometro,
    resetCronometro,
  } = useCronometro({
    selectTime,
    onComplete: () => handleSelectTime(selectTime),
  });

  // O cliente selecionado é usado em dois lugares do autocomplete: como `value`
  // e para montar o selo do campo. O "" é o valor vazio que o Autocomplete
  // espera quando nada está escolhido.
  const clienteSelecionado =
    allClients.find((cliente) => cliente?.id === filterData?.clienteId) || "";

  return (
    <>
      <FilterBar
        actions={actions}
        selectorComponentLeft={
          <Box
            sx={{
              display: "flex",
              gap: 1,
              "@media (max-width:1349px)": {
                flexDirection: "column",
              },
              width: "100%",
            }}
          >
            <Box sx={styles.autocompleteFilter}>
              <VirtualizedAutocomplete
                disabled={loadingClient}
                size="small"
                options={allClients}
                value={clienteSelecionado}
                getOptionLabel={(option) => getClienteOptionLabel(option)}
                renderOption={renderOpcaoCliente()}
                onChange={(event, value) => {
                  localStorage.removeItem("filterData");
                  setStorageFilterData(null);
                  setSelectedHostOption(null);

                  resetCronometro();

                  setFilterData((prev) => ({
                    ...prev,
                    clienteId: value?.id || "",
                    serviceId: "",
                    interfaceId: "",
                    hostId: "",
                  }));

                  if (window.location.pathname.includes("/interno/easyflow")) {
                    const clientStorage = {
                      interfaceId: "",
                      clienteId: value?.id,
                      hostId: "",
                      selectTime: 5,
                      initialDate: filterData?.initialDate || "",
                      finalDate: filterData?.finalDate || "",
                    };

                    localStorage.setItem(
                      "filterData",
                      JSON.stringify(clientStorage),
                    );
                  }
                }}
                renderInput={(params) => (
                  <CampoCliente
                    params={params}
                    option={clienteSelecionado}
                    label="Cliente"
                    sx={{
                      fontSize: "0.75rem", // diminui fonte geral
                    }}
                  />
                )}
              />
              {loadingClient && <LinearProgress />}
            </Box>
            {window.location.pathname.includes("/interno/dash/flow") && (
              <Autocomplete
                multiple
                disableCloseOnSelect
                size="small"
                options={propsLayout?.gruposFlowCliente?.allGruposCliente || []}
                value={pendingGrupos}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                getOptionLabel={(option) => option?.grupoName || ""}
                onChange={(event, newValue, reason) => {
                  setPendingGrupos(newValue || []);

                  if (reason === "clear") {
                    setPropsLayout((prev) => ({
                      ...prev,
                      gruposFlowCliente: {
                        ...prev.gruposFlowCliente,
                        selectGrupos: [],
                      },
                    }));
                  }
                }}
                onClose={() => {
                  setPropsLayout((prev) => ({
                    ...prev,
                    gruposFlowCliente: {
                      ...prev.gruposFlowCliente,
                      selectGrupos: pendingGrupos,
                    },
                  }));
                }}
                renderOption={(props, option, { selected }) => (
                  <li {...props} key={option.id}>
                    <Checkbox style={{ marginRight: 8 }} checked={selected} />

                    <Chip
                      key={option.id}
                      label={option.grupoName}
                      size="small"
                      sx={{
                        ...styles.chipOption,
                        backgroundColor: option?.colorGrupo,
                      }}
                    />
                  </li>
                )}
                renderTags={(value, getTagProps) => {
                  if (value.length === 0) return null;

                  const first = value[0];
                  const extraCount = value.length - 1;
                  const { onDelete, ...tagProps } = getTagProps({ index: 0 });

                  return (
                    <Box sx={styles.boxRenderChip}>
                      {/* CHIP PRINCIPAL */}
                      <Chip
                        key={first.id}
                        label={first.grupoName}
                        size="small"
                        {...tagProps}
                        sx={{
                          backgroundColor: first?.colorGrupo,
                          flex: 1,
                          minWidth: 0,
                          color: theme.palette.white.main,
                          fontWeight: "bold",
                          marginRight: extraCount > 0 ? 0.5 : 0,
                          // Garante que o cursor de "texto" não apareça sobre o chip
                          cursor: "inherit",
                          "& .MuiChip-label": {
                            display: "block",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            paddingLeft: 1,
                            paddingRight: 1,
                          },
                        }}
                      />

                      {/* CHIP CONTADOR */}
                      {extraCount > 0 && (
                        <Chip
                          key="extra"
                          label={`+${extraCount}`}
                          size="small"
                          sx={{
                            flex: "0 0 auto",
                            cursor: "inherit",
                            color: theme.palette.white.main,
                            backgroundColor: "chip.main.arquive",
                            fontWeight: "bold",
                          }}
                        />
                      )}
                    </Box>
                  );
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Grupos Flow"
                    size="small"
                    sx={{
                      fontSize: "0.75rem",
                    }}
                  />
                )}
                sx={{
                  ...styles.autocompleteFilter,
                  "& .MuiAutocomplete-inputRoot": {
                    flexWrap: "nowrap !important",
                    paddingRight: "9px !important",
                  },
                  "& .MuiAutocomplete-tag": {
                    margin: 0,
                  },
                }}
              />
            )}
            <Box
              sx={{
                ...styles.autocompleteFilter,
                display: window.location.pathname.includes("/interno/dash/flow")
                  ? "none"
                  : "block",
              }}
            >
              <Autocomplete
                disabled={loadingService}
                id="service-autocomplete"
                freeSolo
                size="small"
                options={filteredServicesOptions || []}
                groupBy={
                  filteredServicesOptions?.some((service) => service?.ownerNome)
                    ? (option) => option?.ownerNome || ""
                    : undefined
                }
                value={
                  (Array.isArray(allServicesCliente) &&
                    allServicesCliente?.find(
                      (service) =>
                        service?.id_cliente_servico?.toString() ===
                        filterData?.serviceId?.toString(),
                    )) ||
                  ""
                }
                getOptionLabel={(option) =>
                  option
                    ? `${option?.id_cliente_servico} - ${option?.nome}`
                    : ""
                }
                onChange={(event, value) => {
                  localStorage.removeItem("filterData");
                  setSelectedHostOption(null);
                  resetCronometro();
                  setFilterData((prev) => ({
                    ...prev,
                    serviceId: value?.id_cliente_servico?.toString() || "",
                    interfaceId: "",
                    hostId: "",
                  }));
                }}
                sx={{}}
                renderInput={(params) => (
                  <TextField
                    size="small"
                    sx={{
                      fontSize: "0.75rem", // diminui fonte geral
                    }}
                    {...params}
                    label={labelErp}
                  />
                )}
                filterOptions={(options, params) => {
                  // Se a pesquisa normal não encontrar nada, ou se você quiser forçar a busca em outros campos:
                  return options.filter(
                    (option) =>
                      option.nome
                        ?.toLowerCase()
                        .includes(params.inputValue.toLowerCase()) ||
                      option.id_cliente_servico
                        ?.toString()
                        .includes(params.inputValue) ||
                      option.referencia
                        ?.toLowerCase()
                        .includes(params.inputValue.toLowerCase()) ||
                      option.ownerNome
                        ?.toLowerCase()
                        .includes(params.inputValue.toLowerCase()),
                  );
                }}
                renderOption={(props, option) => {
                  const { key, ...optionProps } = props;

                  // Função para renderizar o contador de forma elegante e sutil
                  const renderHostCount = (count) => (
                    <span
                      style={{
                        ...styles.chipHost,
                        ...(count > 0 && {
                          backgroundColor: theme.palette.colors.green.medium,
                          color: theme.palette.white.main,
                        }),
                      }}
                    >
                      {count || 0} {count === 1 ? "host" : "hosts"}
                    </span>
                  );

                  // Se não houver referência, renderiza o formato simples (padrão)
                  if (!option.referencia) {
                    return (
                      <li key={key} {...optionProps}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                            alignItems: "center",
                          }}
                        >
                          <span>{`${option.id_cliente_servico} - ${option.nome}`}</span>
                          {renderHostCount(option.itemsCount)}
                        </div>
                      </li>
                    );
                  }

                  // Se houver referência, renderiza o formato personalizado
                  return (
                    <li key={key} {...optionProps}>
                      <Box sx={{ ...styles.boxLine, width: "100%" }}>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                            alignItems: "center",
                          }}
                        >
                          <span style={{ fontWeight: "bold" }}>
                            {`${option.id_cliente_servico} - ${option.nome}`}
                          </span>
                          {renderHostCount(option.itemsCount)}
                        </div>

                        {option.referencia?.trim() && (
                          <>
                            <Divider sx={{ margin: "2px 0" }} />
                            <span style={{ fontSize: "0.85rem", opacity: 0.9 }}>
                              <span style={{ fontWeight: "bold" }}>
                                {configErp(option?.invertInfo, option?.ownerClienteId).labelRef}:
                              </span>{" "}
                              {option.referencia}
                            </span>
                          </>
                        )}
                      </Box>
                    </li>
                  );
                }}
              />
              {loadingService && <LinearProgress />}
            </Box>
            <Box
              sx={{
                ...styles.autocompleteFilter,
                display: window.location.pathname.includes("/interno/dash/flow")
                  ? "none"
                  : "block",
              }}
            >
              <Autocomplete
                loading={loadingHostsGroupedByType}
                disabled={loadingHostsGroupedByType || !filterData?.clienteId}
                id="host-autocomplete"
                size="small"
                options={hostsOptions || []}
                value={selectedHostOption}
                getOptionLabel={(option) => option?.host || ""}
                // Valida a correspondência do host considerando variações de chaves de identificação
                isOptionEqualToValue={(option, value) => {
                  const optId = option?.hostId || option?.hostid || option?.id;
                  const valId = value?.hostId || value?.hostid || value?.id;
                  return Boolean(
                    optId && valId && String(optId) === String(valId),
                  );
                }}
                onChange={(event, value) => {
                  resetCronometro();
                  setSelectedHostOption(value);
                  setFilterData((prev) => ({
                    ...prev,
                    hostId: value?.hostId || "",
                    device: value?.device,
                    interfaceId: "",
                    fabricante: value?.fabricante || null,
                    funcao: value?.funcao || null,
                    modelo: value?.modelo || null,
                  }));
                }}
                renderInput={(params) => (
                  <TextField {...params} size="small" label="Host" />
                )}
              />
              {loadingHostsGroupedByType && !loadingClient && (
                <LinearProgress />
              )}
            </Box>
            <Box
              sx={{
                ...styles.autocompleteFilter,
                display:
                  window.location.pathname.includes("/interno/dash/bgp") ||
                  window.location.pathname.includes("/interno/dash/flow") ||
                  window.location.pathname.includes("/interno/dash/firewall") ||
                  selectedHostOption?.groups?.some((group) =>
                    group?.name?.includes("ICMP"),
                  )
                    ? "none"
                    : "block",
              }}
            >
              <Autocomplete
                disabled={
                  loadingInterfaceOptions ||
                  loadingSfpCache ||
                  !selectedHostOption
                }
                id="interface-autocomplete"
                freeSolo
                size="small"
                options={interfaceOptions?.filter((option) => {
                  if (option === null || option === undefined) return false;
                  if (selectedHostOption?.hostsClienteInterfaces?.length > 0) {
                    return selectedHostOption.hostsClienteInterfaces.some(
                      (iface) => {
                        const name =
                          typeof iface === "string" ? iface : iface?.interface;
                        return name === option?.name;
                      },
                    );
                  }
                  return true;
                })}
                isOptionEqualToValue={(option, value) => {
                  const optVal =
                    typeof option === "string" ? option : option?.name;
                  const valVal =
                    typeof value === "string" ? value : value?.name;
                  return optVal === valVal;
                }}
                getOptionLabel={(option) => {
                  if (typeof option === "string") return option;
                  if (option?.description)
                    return `${option.name} - ${option.description}`;
                  return option?.name || "";
                }}
                renderOption={(props, option) => {
                  let tags = [];
                  if (selectedHostOption?.hostsClienteInterfaces) {
                    const found =
                      selectedHostOption.hostsClienteInterfaces.find((i) => {
                        const name = typeof i === "string" ? i : i?.interface;
                        return name === option?.name;
                      });
                    if (found && typeof found !== "string" && found.tags) {
                      tags = found.tags;
                    }
                  }

                  let label = option?.name || "";
                  if (option?.description)
                    label = `${option.name} - ${option.description}`;

                  return (
                    <li
                      {...props}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      <span>{label}</span>
                      {tags.length > 0 && (
                        <Box
                          sx={{
                            display: "flex",
                            gap: 0.5,
                            flexWrap: "wrap",
                            justifyContent: "flex-end",
                            maxWidth: "150px",
                          }}
                        >
                          {tags.map((t) => (
                            <Chip
                              key={t.id}
                              label={t.tagName}
                              size="small"
                              sx={{
                                height: 12,
                                fontSize: "0.65rem",
                                color: "#fff",
                                bgcolor: t.colorTag || "#ccc",
                                fontWeight: "bold",
                              }}
                            />
                          ))}
                        </Box>
                      )}
                      {location.pathname === "/interno/dash/sfp" &&
                        sfpInterfacesCache[option?.name] !== undefined && (
                          <span
                            style={{
                              ...styles.chipHost,
                              ...(sfpInterfacesCache[option?.name] && {
                                backgroundColor:
                                  theme.palette.colors.green.medium,
                                color: theme.palette.white.main,
                              }),
                            }}
                          >
                            {sfpInterfacesCache[option?.name]
                              ? "1 Transceptor"
                              : "0 Transceptor"}
                          </span>
                        )}
                    </li>
                  );
                }}
                value={
                  (typeof filterData?.interfaceId === "string"
                    ? interfaceOptions?.find(
                        (opt) => opt?.name === filterData?.interfaceId,
                      ) || filterData?.interfaceId
                    : filterData?.interfaceId) || ""
                }
                onChange={(event, value) => {
                  resetCronometro();
                  setFilterData((prev) => ({
                    ...prev,
                    interfaceId: value?.name || value || "",
                  }));
                }}
                renderInput={(params) => {
                  let endAdornment = params.InputProps.endAdornment;
                  if (
                    filterData?.interfaceId &&
                    selectedHostOption?.hostsClienteInterfaces
                  ) {
                    const found =
                      selectedHostOption.hostsClienteInterfaces.find((i) => {
                        const name = typeof i === "string" ? i : i?.interface;
                        return name === filterData?.interfaceId;
                      });
                    if (
                      found &&
                      typeof found !== "string" &&
                      found.tags &&
                      found.tags.length > 0
                    ) {
                      const chips = found.tags.map((t) => (
                        <Chip
                          key={t.id}
                          label={t.tagName}
                          size="small"
                          sx={{
                            height: 12,
                            fontSize: "0.65rem",
                            color: "#fff",
                            bgcolor: t.colorTag || "#ccc",
                            fontWeight: "bold",
                            ml: 0.5,
                          }}
                        />
                      ));
                      if (
                        location.pathname === "/interno/dash/sfp" &&
                        sfpInterfacesCache[filterData?.interfaceId] !==
                          undefined
                      ) {
                        chips.unshift(
                          <span
                            key="sfp-badge"
                            style={{
                              ...styles.chipHost,
                              ...(sfpInterfacesCache[
                                filterData?.interfaceId
                              ] && {
                                backgroundColor:
                                  theme.palette.colors.green.medium,
                                color: theme.palette.white.main,
                              }),
                              marginRight: "4px",
                              fontSize: "0.7rem",
                              lineHeight: 1,
                              padding: "2px 4px",
                            }}
                          >
                            {sfpInterfacesCache[filterData?.interfaceId]
                              ? "1 Transceptor"
                              : "0 Transceptor"}
                          </span>,
                        );
                      }
                      endAdornment = (
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          {chips}
                          {endAdornment}
                        </Box>
                      );
                    } else if (
                      location.pathname === "/interno/dash/sfp" &&
                      sfpInterfacesCache[filterData?.interfaceId] !== undefined
                    ) {
                      endAdornment = (
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          {/* <span
                            key="sfp-badge"
                            style={{
                              ...styles.chipHost,
                              ...(sfpInterfacesCache[filterData?.interfaceId] && {
                                backgroundColor: theme.palette.colors.green.medium,
                                color: theme.palette.white.main,
                              }),
                              marginRight: "4px",
                              fontSize: "0.7rem",
                              lineHeight: 1,
                              padding: "2px 4px",
                            }}
                          >
                            {sfpInterfacesCache[filterData?.interfaceId] ? "1 Transceptor" : "0 Transceptor"}
                          </span>
                          {endAdornment} */}
                        </Box>
                      );
                    }
                  }

                  return (
                    <TextField
                      size="small"
                      {...params}
                      label={`${deviceConfig?.metaData?.ifLabel || "Interface"}`}
                      InputProps={{
                        ...params.InputProps,
                        endAdornment: endAdornment,
                      }}
                      sx={{
                        fontSize: "0.75rem",
                      }}
                    />
                  );
                }}
              />

              {loadingInterfaceOptions && <LinearProgress />}
            </Box>
          </Box>
        }
        selectorComponentRight={
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Cronometro
              counter={counter}
              selectTime={selectTime}
              loadingCronometro={loadingCronometro}
              windowWidth={windowWidth}
            />
            {!isConexoes && (
              <ButtonTime
                open={open}
                optionsTime={propsLayout?.optionsTime || optionsTime}
                selectTime={selectTime}
                handleClick={handleClick}
                anchorEl={anchorEl}
                handleClose={handleClose}
                loading={loadingHostsGroupedByType}
                handleStartChange={handleStartChange}
                handleEndChange={handleEndChange}
                handleAplicar={handleAplicar}
                isValidRange={isValidRange}
                endDate={endDate}
                startDate={startDate}
                setEndDate={setEndDate}
                setStartDate={setStartDate}
                setSelectTime={setSelectTime}
                handleSelectTime={handleSelectTime}
                filterData={filterData}
                DateTime={DateTimePicker}
                todayMaxDataTime={
                  propsLayout?.rangeDays
                    ? startDate
                      ? dayjs.min(
                          dayjs(startDate).add(propsLayout?.rangeDays, "day"),
                          dayjs(),
                        )
                      : null
                    : null
                }
              />
            )}

            {windowWidth >= 1350 && (
              <>
                {!window.location.pathname.includes("/interno/dash/flow") && (
                  <Tooltip title="Opções de Acesso">
                    <span>
                      <Button
                        size="small"
                        variant="outlined"
                        disabled={!remoteAccessReady}
                        onClick={handleOpenAcessoMenu}
                        sx={styles.buttonRefresh}
                      >
                        <MenuIcon
                          fontSize="small"
                          sx={{ color: theme.palette.text.main }}
                        />
                      </Button>
                    </span>
                  </Tooltip>
                )}

                <Menu
                  anchorEl={anchorElAcesso}
                  open={openAcesso}
                  onClose={handleCloseAcessoMenu}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                >
                  <MenuItem
                    onClick={() => {
                      handleCloseAcessoMenu();
                      handleOpenRemoteAccess();
                    }}
                  >
                    <ListItemIcon>
                      <SettingsRemote fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Acesso Remoto</ListItemText>
                  </MenuItem>
                  <MenuItem onClick={handleAbrirAcessoHttp}>
                    <ListItemIcon>
                      <HttpOutlined fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Acesso HTTP</ListItemText>
                  </MenuItem>
                </Menu>
                <Button
                  size="small"
                  variant="outlined"
                  disabled={
                    loadingCronometro || !(selectTime || selectTime === 0)
                  }
                  onClick={() => handleSelectTime(selectTime)}
                  sx={{
                    ...styles.buttonRefresh,

                    "& .rotating": {
                      animation: "spin 1s linear infinite",
                    },
                    "@keyframes spin": {
                      "0%": { transform: "rotate(0deg)" },
                      "100%": { transform: "rotate(-360deg)" },
                    },
                  }}
                >
                  <Cached
                    fontSize="small"
                    sx={{ color: theme.palette.text.main }}
                    className={loadingCronometro ? "rotating" : ""}
                  />
                </Button>
              </>
            )}
          </Box>
        }
        windowWidth={30000}
        openFilter={openFilter}
        setOpenFilter={setOpenFilter}
        type={1}
      />

      <Box component="main">
        {Array.isArray(filteredServicesOptions) &&
        filterData?.serviceId &&
        filteredServicesOptions?.find(
          (service) =>
            service?.id_cliente_servico?.toString() ===
            filterData?.serviceId?.toString(),
        )?.itemsCount === 0 ? (
          <ConfusedMale
            mainFill={theme.palette.secondary.dark}
            primaryCircleFill={theme.palette.secondary.main}
            highlightTitle={"Oops !"}
            subtitle={`Parece que o serviço \n${filterData?.serviceId} não foi configurado.`}
            buttonName={`Configurar serviço`}
            functionButton={() => {
              navigate(`/interno/home/perfil/config/${filterData?.clienteId}`);
            }}
          />
        ) : (
          <Box>
            <Outlet
              context={{
                filterData,
                handleAplicarZoom,
                setCounter,
                setLoadingCronometro,
                selectTime,
                optionsTime,
                startCronometro,
                controllerDashboard,
                setControllerDashboard,
                toggleDrawer,
                api,
                stopCronometro,
                deviceConfig,
                setPropsLayout,
                propsLayout,
                sfpInterfacesCache,
                setSfpInterfacesCache,
              }}
            />
          </Box>
        )}
      </Box>
      {!!snackbar && (
        <Snackbar
          open
          onClose={() => setSnackbar(null)}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert {...snackbar} onClose={() => setSnackbar(null)} />
        </Snackbar>
      )}

      <ModalAcessoHttp
        open={openHttpModal}
        onClose={() => setOpenHttpModal(false)}
        data={httpCredentials}
        hostName={selectedHostOption?.host || ""}
      />
    </>
  );
}
